export const Botad = {
    title: "Botad",
    title1: "(Historical & Cultural)",

    attractions: [
        {
            name: "Shree Swaminarayan Mandir",
            description: "A significant pilgrimage site, this temple is dedicated to Lord Swaminarayan and showcases beautiful architecture with intricate carvings. Devotees from across Gujarat visit the temple for spiritual peace and blessings.",
            location: "Swaminarayan Road, Botad, Gujarat",
            timings: "6:00 AM to 8:00 PM",
            ticket: "Free Entry",
            bestTimeToVisit: "Early Morning or Evening",
            activities: [
                "Attend morning and evening Aarti",
                "Explore the temple architecture",
                "Participate in spiritual discourses",
                "Enjoy the peaceful ambiance",
                "Shop for religious souvenirs"
            ],
            mapLink: "https://maps.app.goo.gl/XYZ123",
        },
        {
            name: "Gadhada Swaminarayan Temple",
            description: "One of the six temples built by Lord Swaminarayan himself, Gadhada temple is a major religious center with stunning carvings and a rich spiritual atmosphere.",
            location: "Gadhada, near Botad, Gujarat",
            timings: "5:30 AM to 9:00 PM",
            ticket: "Free Entry",
            bestTimeToVisit: "Morning or Evening",
            activities: [
                "Attend traditional prayers and rituals",
                "Explore temple premises and history",
                "Enjoy the calm surroundings",
                "Purchase religious books and items"
            ],
            mapLink: "https://maps.app.goo.gl/ABC456",
        },
        {
            name: "Dholidhaja Dam",
            description: "A scenic spot near Botad, Dholidhaja Dam is a great place for nature lovers and those looking for a peaceful escape. The dam provides water to the region and offers a serene environment with lush greenery.",
            location: "Near Botad, Gujarat",
            timings: "Open 24 Hours",
            ticket: "Free Entry",
            bestTimeToVisit: "Monsoon and Winter Season",
            activities: [
                "Enjoy the peaceful atmosphere",
                "Birdwatching and photography",
                "Take a short trek around the dam area",
                "Have a picnic with family and friends"
            ],
            mapLink: "https://maps.app.goo.gl/LMN789",
        },
        {
            name: "Bhavani Mata Temple",
            description: "A revered temple dedicated to Goddess Bhavani, this temple is known for its religious importance and the stunning views it offers from the hilltop location.",
            location: "Near Botad, Gujarat",
            timings: "6:00 AM to 7:00 PM",
            ticket: "Free Entry",
            bestTimeToVisit: "Navratri Festival or Winter Season",
            activities: [
                "Offer prayers and seek blessings",
                "Enjoy the scenic hilltop views",
                "Attend special Navratri celebrations",
                "Trekking to the temple site"
            ],
            mapLink: "https://maps.app.goo.gl/XYZ999",
        },
        {
            name: "Shree Kashtbhanjan Hanuman Mandir",
            description: "A famous temple dedicated to Lord Hanuman, known for its powerful spiritual aura and its importance among devotees who seek protection and strength.",
            location: "Sarangpur, near Botad, Gujarat",
            timings: "5:00 AM to 9:00 PM",
            ticket: "Free Entry",
            bestTimeToVisit: "Saturdays and Hanuman Jayanti",
            activities: [
                "Attend the Aarti and Bhajan sessions",
                "Experience the divine ambiance",
                "Explore the temple surroundings",
                "Purchase religious items"
            ],
            mapLink: "https://maps.app.goo.gl/SarangpurHanuman",
        },
        {
            name: "Paliyad Jain Temple",
            description: "An important religious site for Jains, Paliyad Jain Temple is known for its peaceful ambiance and stunning marble architecture. It is visited by pilgrims from all over Gujarat.",
            location: "Paliyad, near Botad, Gujarat",
            timings: "6:00 AM to 8:00 PM",
            ticket: "Free Entry",
            bestTimeToVisit: "Winter Season",
            activities: [
                "Offer prayers and seek blessings",
                "Explore the temple architecture",
                "Attend religious discourses",
                "Enjoy the serene surroundings"
            ],
            mapLink: "https://maps.app.goo.gl/PaliyadJainTemple",
        },
        {
            name: "Navghan Kuvo",
            description: "A historic stepwell that holds great significance in local folklore, Navghan Kuvo is a must-visit site for history enthusiasts. The well is known for its impressive construction and historical importance.",
            location: "Near Botad, Gujarat",
            timings: "Open 24 Hours",
            ticket: "Free Entry",
            bestTimeToVisit: "Winter Season",
            activities: [
                "Explore the stepwell’s architecture",
                "Learn about its historical importance",
                "Photography and sightseeing"
            ],
            mapLink: "https://maps.app.goo.gl/NavghanKuvo",
        }
    ]
};
